import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { useAuthForm } from "@/hooks/useAuthForm";
import { LoginForm } from "@/components/auth/LoginForm";
import { RegisterForm } from "@/components/auth/RegisterForm";

export const SignInModal = ({ open, onOpenChange, initialTab = "signin", initialRole = null }) => {
  const [tab, setTab] = useState(initialTab);
  const authForm = useAuthForm(() => onOpenChange(false));

  useEffect(() => {
    if (open) {
      setTab(initialTab);
      if (initialRole) authForm.setForm((f) => ({ ...f, role: initialRole }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open, initialTab, initialRole]);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="signin-modal" className="max-w-md rounded-2xl max-h-[88vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle className="font-heading text-2xl text-rr-navy">
            {tab === "signin" ? "Sign In to RelayRigs" : "Create Your RelayRigs Account"}
          </DialogTitle>
          <DialogDescription>
            {tab === "signin" ? "Sign in with your RelayRigs app account." : "Register a RelayRigs account and activate your membership."}
          </DialogDescription>
        </DialogHeader>

        <div className="flex bg-rr-surface rounded-full p-1 mb-2">
          <button data-testid="signin-tab-signin" onClick={() => setTab("signin")} className={`flex-1 text-sm font-bold py-2 rounded-full transition-colors ${tab === "signin" ? "bg-white shadow text-rr-navy" : "text-rr-muted"}`}>
            Sign In
          </button>
          <button data-testid="signin-tab-register" onClick={() => setTab("register")} className={`flex-1 text-sm font-bold py-2 rounded-full transition-colors ${tab === "register" ? "bg-white shadow text-rr-navy" : "text-rr-muted"}`}>
            Create Account
          </button>
        </div>

        {tab === "signin" ? (
          <LoginForm
            form={authForm.form}
            update={authForm.update}
            showPassword={authForm.showPassword}
            setShowPassword={authForm.setShowPassword}
            loading={authForm.loading}
            onSubmit={authForm.handleLogin}
            onGoogle={authForm.handleGoogleSignIn}
          />
        ) : (
          <RegisterForm
            form={authForm.form}
            setForm={authForm.setForm}
            update={authForm.update}
            toggleArrayValue={authForm.toggleArrayValue}
            loading={authForm.loading}
            isDriverRole={authForm.isDriverRole}
            isCarrierRole={authForm.isCarrierRole}
            isBrokerRole={authForm.isBrokerRole}
            onSubmit={authForm.handleRegister}
          />
        )}
      </DialogContent>
    </Dialog>
  );
};
